import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

import { GetCompany } from 'query';
import { classnames, classname } from 'utils';

import './SearchResult.css';

/**
 * Результаты поиска
 */
class SearchResult extends Component {
  cl = classname('search-result');

  static propTypes = {
    /** Доп. класс */
    className: PropTypes.string
  };

  render() {
    const { className, data } = this.props;

    const classes = classnames(className, this.cl());

    return (
      <div className={classes}>
        {data.length > 0 ? (
          <div className={this.cl('list')}>
            {data.map(({ title, uri }) => (
              <Link to={uri} className={this.cl('item')} key={title}>
                {title}
              </Link>
            ))}
          </div>
        ) : (
          <div className={this.cl('title')}>Ничего не найдено</div>
        )}
      </div>
    );
  }
}

export default ({ search, ...props }) => (
  <GetCompany options={{ title: search }}>{data => <SearchResult data={data} {...props} />}</GetCompany>
);
